import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { studio, whatsappLink } from '../mock';

export default function StickyFooterBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-black/8 bg-[#f7f6f2]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)] md:hidden">
      <div className="mx-auto grid max-w-[520px] grid-cols-2 gap-2 px-3 py-2.5">
        <a
          href={studio.phoneHref}
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#ff5a1f] px-4 py-3 text-sm font-semibold text-white active:scale-[0.98] transition-transform"
        >
          <Phone className="h-4 w-4" />
          Call
        </a>
        <a
          href={whatsappLink()}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white active:scale-[0.98] transition-transform"
        >
          <MessageCircle className="h-4 w-4 fill-white" />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
